module.exports = require("deepmerge")(require("./config.default.js"), {
  native: {
    appleTeamId: "2BAP3P29V2",
    name: {
      default: "MCB_D"
    },
    id: "com.mobilespot.mcb.dev",
    appleAppId: "2BAP3P29V2"
  },
  // which additional repos need to be cloned
  relatedRepos: [{
    src: "git@bitbucket.org:mobilespotdev/cordova.git",
    branch: "inte/mcb2022/main",
    postCommands: ["cd cordova && npm install"]
  }, {
    src: "git@bitbucket.org:mobilespotdev/mobigeo.git",
    branch: "inte/mcb2022/main",
    postCommands: ["cd mobigeo && npm install"]
  }, {
    src: "git@bitbucket.org:mobilespotdev/mobigeo-customs-mcb.git",
    branch: "inte/mcb2022/main",
    dest: "mobigeo/mobigeo-customs"
  }, {
    src: "git@bitbucket.org:mobilespotdev/app-react.git",
    branch: "inte/mcb2022/main"
  }, {
    src: "git@bitbucket.org:mobilespotdev/data-mcb-2022.git",
    branch: "inte/mcb2022/main",
    dest: "app-react/data",
    postCommands: ["cd app-react && yarn", "cd app-react && npm run set-env dev", "cd app-react && npm run download-assets", "cd app-react && npm run download-data-files", "cd app-react && npm run update-mobigeo"]
  }],
  web: {
    url: "mcb2022.ms-dev.mobile-spot.com"
  }
});